module.exports = __webpack_public_path__ + "img/tg-3.b51451bc.png";